import { useEffect, useRef } from "react";
import { toast } from "react-toastify";

export default function useLoadingToaster({
  state: { isLoading, isError, isSuccess },
  renderMessages: { success, error, loading },
}) {
  const toasterIdRef = useRef(null);

  useEffect(() => {
    if (isLoading) toasterIdRef.current = toast.loading(loading);
    if (isError)
      toast.update(toasterIdRef.current, {
        type: "error",
        autoClose: 1000,
        render: error,
        isLoading: false,
      });

    if (isSuccess)
      toast.update(toasterIdRef.current, {
        render: success,
        isLoading: false,
        autoClose: 1000,
        type: "success",
      });
  }, [error, isError, isLoading, isSuccess, loading, success]);
}
